export enum CustomerFrontAppSwitches {
  // Display pension products breakdown grouped by insured contact, rather than for the whole customer
  pension_breackdown_per_contact = 'customer-front.pension.breakdown.perContact',
}
